<template>
  <ScModal
    :show="show"
    class="update-field-modal"
    @close="close"
  >
    <form
      v-if="show"
      @submit.prevent="onSubmit"
      novalidate
    >
      <div class="modal-header">
        <h5 class="modal-title">
          {{ title }}
        </h5>
        <button
          type="button"
          class="close"
          @click="close"
        >
          <span>&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <div class="form-input">
          <ScLabel>
            {{ label }}
          </ScLabel>
          <input
            :class="{'is-invalid' : !!errors.has(name), 'form-control': true}"
            type="text"
            v-validate="validation"
            :name="name"
            :key="name"
            :data-vv-name="name"
            :data-vv-as="name"
            v-model="inputValue"
            :placeholder="placeholder"
            v-mask:autoUnmask="mask"
          >
          <span
            v-if="errors.has(name)"
            class="error-message"
          >
            {{ errors.first(name) }}
          </span>
        </div>
      </div>
      <div class="modal-footer">
        <ScButton
          type="submit"
          class="form-button"
          :disabled="!canSubmit"
        >
          {{ $t(`account.save`) }}
        </ScButton>
      </div>
    </form>
  </ScModal>
</template>

<script>

import ScLabel from '@trendyol/sc-ui-kit/ScLabel';
import ScModal from '@trendyol/sc-ui-kit/ScModal';
import ScButton from '@trendyol/sc-ui-kit/ScButton';

export default {
  name: 'UpdateFieldModal',
  components: {
    ScButton,
    ScLabel,
    ScModal,
  },

  props: {
    title: {
      type: String,
      default: '',
    },
    label: {
      type: String,
      default: '',
    },
    placeholder: {
      type: String,
      default: '',
    },
    mask: {
      type: String,
      default: '',
    },
    name: {
      type: String,
      default: '',
    },
    validation: {
      type: Object,
      default: () => ({}),
    },
    value: {
      type: String,
      default: '',
    },
    show: {
      type: Boolean,
      default: false,
    },
  },

  created () {
    const dict = {
      custom: {
        mersisNo: {
          required: `${this.label} bilgisi zorunlu bir alandır.`,
        },
        kepAddress: {
          required: `${this.label} bilgisi zorunlu bir alandır.`,
          regex: `${this.label} formatı geçersizdir.`,
        },
      },
    };

    this.$validator.localize('tr', dict);
  },

  data () {
    return {
      inputValue: this.value,
    };
  },

  computed: {
    canSubmit () {
      return !this.errors.has(this.name) && this.value !== this.inputValue;
    },
  },

  watch: {
    show () {
      this.inputValue = '';
    },
    value (newValue) {
      this.inputValue = newValue;
    },
  },

  methods: {
    close () {
      this.errors.clear();
      this.$emit('close');
    },
    async onSubmit () {
      const isValid = await this.$validator.validate();
      if (isValid) { this.$emit('submit', this.inputValue, this.name); }
    },
  },
};
</script>

<style lang="scss" scoped>
  .update-field-modal{
    & .modal-header{
      padding: 35px 30px 25px 30px;
      & .modal-title{
        font-size: 20px !important;
      }
    }
    & .modal-body{
      padding: 0 30px;

      .message-wrapper {
        margin-bottom: 30px;
        color: #273142;
        font-weight: 500;
        text-align: center;
        font-size: 20px;
        display: flex;
        align-items: center;
        flex-direction: column;

        img {
          margin-bottom: 30px;
        }
      }

      & .form-input {
        position: relative;
        &:not(:first-child) {
          margin-top: 20px;
        }
        &::v-deep input{
          height: 40px;
        }
        & .invalid{
          &::v-deep input{
            border-color: #dc3545;
          }
          &::v-deep .eye-icon:before{
            color: #dc3545;
          }
        }
      }
      .error-message {
        position: absolute;
        color: #dc3545;
      }
    }

    & .modal-footer{
      padding: 30px;
      border-top: none;
      & .form-button {
        width: 100%;
        height: 40px;
      }
    }
  }
</style>
